import { z } from 'zod'

export const loginSchema = z.object({
  login: z.string().min(1, 'Verifique seu e-mail ou CPF'),
  password: z.string().min(1, 'Verifique sua senha'),
})
